import { Component } from '@angular/core';
import { BundleType } from 'wms-lib';
import { CatalogComponent } from '../../base-components/catalog.component';

@Component({
    selector: 'app-bundle-types',
    templateUrl: './bundle-types.component.html',
    styleUrls: ['../catalogs.component.sass']
})
export class BundleTypesComponent extends CatalogComponent<BundleType> {
    name_catalog = 'bundle_types';


    addNew(_type?: string) {
        let c = this.newItem({name_es: '', name_en: '', type: _type, cost: 0});
        this.items[c.id] = c;
        this.items = {...this.items};
    }

    newItem(data: any) {
        return new  BundleType(data);
    }
}

